// Enhanced Product Cards - Super Cart Compatible
(function () {
  function initializeProductCards() {
    // Gallery Handler
    document.querySelectorAll('[data-gallery]').forEach((gallery) => {
      if (gallery.dataset.initialized === 'true') return;

      const track = gallery.querySelector('.pc-track');
      const dots = gallery.querySelectorAll('.pc-dot');
      const slides = gallery.querySelectorAll('.pc-slide');

      if (!track || slides.length <= 1) return;

      let currentIndex = 0;

      dots.forEach((dot, index) => {
        dot.addEventListener('click', () => {
          currentIndex = index;
          track.scrollTo({
            left: track.offsetWidth * index,
            behavior: 'smooth',
          });
          updateDots();
        });
      });

      track.addEventListener('scroll', () => {
        const index = Math.round(track.scrollLeft / track.offsetWidth);
        if (index !== currentIndex) {
          currentIndex = index;
          updateDots();
        }
      });

      function updateDots() {
        dots.forEach((dot, i) => {
          dot.classList.toggle('is-active', i === currentIndex);
        });
      }

      gallery.dataset.initialized = 'true';
    });

    function shouldOpenVariantModal(button) {
      return button?.dataset?.hasVariants === 'true';
    }

    function openVariantModal(button) {
      if (!button) return false;

      let modalId = button.getAttribute('aria-controls') || button.dataset.modalId;
      let modal = modalId ? document.getElementById(modalId) : null;

      if (!modal) {
        const card = button.closest('[data-quick-buy-modal-id]');
        const fallbackId = card?.getAttribute('data-quick-buy-modal-id');

        if (fallbackId) {
          modalId = fallbackId;
          modal = document.getElementById(modalId);
        }
      }

      if (modal && typeof modal.show === 'function') {
        modal.show();
        return true;
      }

      return false;
    }

    // Add to Cart Handler - Works with Super Cart
    async function addToCart(button) {
      if (shouldOpenVariantModal(button) && openVariantModal(button)) {
        return;
      }

      const variantId = button.dataset.variant;
      if (!variantId || button.disabled) return;

      button.disabled = true;
      button.classList.add('loading');
      const originalText = button.textContent;

      try {
        // Standard Shopify add to cart
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            id: parseInt(variantId),
            quantity: 1,
          }),
        });

        if (!response.ok) throw new Error('Failed to add');

        const item = await response.json();

        // Check if Super Cart exists
        if (window.SUPERCART || document.querySelector('.supercart-drawer')) {
          // Trigger Super Cart's update
          if (window.SUPERCART && window.SUPERCART.api) {
            window.SUPERCART.api.toggleRightDrawer();
          } else {
            // Fallback: trigger click on Super Cart button
            const superCartTrigger = document.querySelector(
              '[data-supercart-toggle], .supercart-trigger, #supercart-toggle'
            );
            if (superCartTrigger) {
              superCartTrigger.click();
            }
          }
        } else {
          // Fallback to standard cart drawer
          const cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer) {
            cartDrawer.open = true;
          }
        }

        // Update cart count
        fetch('/cart.js')
          .then((res) => res.json())
          .then((cart) => {
            document.querySelectorAll('.header__cart-count, .cart-count, .supercart-quantity').forEach((el) => {
              el.textContent = cart.item_count;
            });
          });

        // Success feedback
        if (button.classList.contains('pc-atc-button')) {
          button.textContent = 'ADDED!';
          setTimeout(() => {
            button.textContent = originalText.toUpperCase();
            button.disabled = false;
            button.classList.remove('loading');
          }, 2000);
        } else {
          button.disabled = false;
          button.classList.remove('loading');
        }
      } catch (error) {
        console.error('Add to cart failed:', error);
        button.disabled = false;
        button.classList.remove('loading');
      }
    }

    // Note: Product card event handlers are now handled globally by product-card.js
    // This avoids duplicate event listeners across different pages

    // Gallery Link Handler
    document.querySelectorAll('[data-gallery-link]').forEach((link) => {
      if (link.dataset.linkInitialized === 'true') return;

      let startX = 0;
      let moved = false;

      link.addEventListener('mousedown', (e) => {
        startX = e.clientX;
        moved = false;
      });

      link.addEventListener('mousemove', (e) => {
        if (Math.abs(e.clientX - startX) > 5) {
          moved = true;
        }
      });

      link.addEventListener('click', (e) => {
        if (moved) {
          e.preventDefault();
        }
      });

      link.addEventListener(
        'touchstart',
        (e) => {
          startX = e.touches[0].clientX;
          moved = false;
        },
        { passive: true }
      );

      link.addEventListener(
        'touchmove',
        (e) => {
          if (Math.abs(e.touches[0].clientX - startX) > 5) {
            moved = true;
          }
        },
        { passive: true }
      );

      link.addEventListener('touchend', (e) => {
        if (moved) {
          e.preventDefault();
        }
      });

      link.dataset.linkInitialized = 'true';
    });
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeProductCards);
  } else {
    initializeProductCards();
  }

  // Reinitialize on dynamic content changes
  document.addEventListener('shopify:section:load', initializeProductCards);
  document.addEventListener('shopify:section:reorder', initializeProductCards);

  // Watch for Super Cart initialization
  let superCartCheckInterval = setInterval(function () {
    if (window.SUPERCART || document.querySelector('.supercart-drawer')) {
      clearInterval(superCartCheckInterval);
    }
  }, 1000);

  // Stop checking after 10 seconds
  setTimeout(() => clearInterval(superCartCheckInterval), 10000);
})();
